import { DragDropContext, Draggable, Droppable } from '@hello-pangea/dnd';
import cn from 'classnames';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';
import { useFieldArray } from 'react-hook-form';

import { Button, Input } from 'components/FormComponents';

import styles from './OptionsList.module.scss';

export const OptionsList = ({ register, name, control, arrayItemTitles, noMargin = false }) => {
  const { fields, append, remove, move } = useFieldArray({ control, name: `${name}.options` });

  const itemLabel = arrayItemTitles || 'option';
  const itemLabelLower = itemLabel.toLowerCase();

  const addOption = () => {
    append({ value: '' });
  };

  const onDragEnd = ({ source, destination }) => {
    if (!source || !destination) return;
    move(source.index, destination.index);
  };

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="options">
        {({ innerRef, droppableProps, placeholder }) => (
          <div
            className={cn(
              'background-secondary card card-with-border u-padding-top u-padding-bottom--small u-padding-x',
              { [styles.rootNoMargin]: noMargin },
            )}
            {...droppableProps}
            ref={innerRef}>
            {fields.map((option, index) => (
              <Option
                key={option.id}
                index={index}
                name={`${name}.options.${index}`}
                register={register}
                option={option}
                onRemove={() => remove(index)}
                onEnter={addOption}
                itemLabel={itemLabelLower}
              />
            ))}
            {placeholder}
            <Button type="link" onClick={addOption}>
              + Add another {itemLabelLower}
            </Button>
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};

const Option = ({ name, register, onRemove, option, index, onEnter, itemLabel = 'option' }) => {
  const handleKeyDown = e => {
    switch (e.code) {
      case 'Enter':
        e.preventDefault();
        onEnter();
        break;
      case 'Backspace':
        if (e.target.value === '') {
          e.preventDefault();
          onRemove();
        }
        break;
    }
  };

  return (
    <Draggable draggableId={option.id} index={index}>
      {({ draggableProps, dragHandleProps, innerRef }) => (
        <div
          className={cn(styles.option, 'd-flex', 'align-items-center')}
          {...draggableProps}
          {...dragHandleProps}
          ref={innerRef}>
          <FeatherIcon icon="move" className={cn('u-margin-right--small', styles.icon)} />
          <Input
            register={register}
            name={`${name}.value`}
            className={styles.input}
            placeholder={`Enter ${itemLabel}...`}
            actionIcon="trash-2"
            onActionClick={onRemove}
            inputProps={{
              onKeyDown: handleKeyDown,
            }}
          />
        </div>
      )}
    </Draggable>
  );
};
